<template>
    <div>
        <v-form ref="form">
            <slot></slot>
        </v-form>
    </div>
</template>

<style scoped></style>
<script setup>
    import { onMounted, ref } from 'vue';

    const form = ref(null);

    onMounted(() => {
        console.log('AppForm is mounted.');
        form.value.resetValidation();
    });
</script>
